import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { bsc } from 'wagmi/chains';
import { http } from 'viem';

// Impor spesifik wallet (Binance Wallet dihapus dari daftar ini)
import {
  trustWallet,
  bitgetWallet,
  metaMaskWallet,
  walletConnectWallet,
  injectedWallet,
  rabbyWallet,
} from '@rainbow-me/rainbowkit/wallets';

const USER_RPC_URL = 'https://rpc.ankr.com/bsc/a7133d7eb25440801943e9b769be4a590bd9657e3585f540691b0e4420de6638'; // Jangan lupa isi RPC BSC kamu

export const config = getDefaultConfig({
  appName: 'Shape App', 
  projectId: '348cc3de0b371dc000f8dbb3920de569', // Jangan lupa isi Project ID
  chains: [bsc],
  transports: {
    [bsc.id]: http(USER_RPC_URL),
  },
  // Urutan wallet disesuaikan
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [
        trustWallet,         // 1. Trust Wallet
        bitgetWallet,        // 2. Bitget Wallet
        metaMaskWallet,      // 3. MetaMask
        walletConnectWallet, // 4. WalletConnect
        injectedWallet,      // 5. Injected Wallet
        rabbyWallet,         // 6. Rabby Wallet
      ],
    },
  ],
  ssr: false,
});